import { QueryCache, QueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { type ApiErrorResponse } from "@/config/apiClient.types";
import { handleReactQueryErrors } from "@/helpers/errors";

export const useQueryClient = () => {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: Number.POSITIVE_INFINITY,
            retry: false,
            refetchOnWindowFocus: false,
          },
          mutations: {
            onError: (error) => handleReactQueryErrors(error),
          },
        },
        queryCache: new QueryCache({
          onError: (error, query) => {
            const processFunc = query?.meta?.onError as (
              error: Error | ApiErrorResponse
            ) => void;
            return handleReactQueryErrors(error, processFunc);
          },
        }),
      }),
    []
  );

  return queryClient;
};
